import { render, staticRenderFns } from "./ElevatorTotal.vue?vue&type=template&id=6a4c784d&scoped=true&"
import script from "./ElevatorTotal.vue?vue&type=script&lang=js&"
export * from "./ElevatorTotal.vue?vue&type=script&lang=js&"
import style0 from "./ElevatorTotal.vue?vue&type=style&index=0&id=6a4c784d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a4c784d",
  null
  
)

export default component.exports